import { render } from "./LinkSentDialogComponent.vue?vue&type=template&id=741b47f0"
import script from "./LinkSentDialogComponent.vue?vue&type=script&lang=js"
export * from "./LinkSentDialogComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__